import type { ReactNode } from 'react';

export const symbol_tv_displays: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M109.82-327Q97-327 88.5-335.63 80-344.25 80-357v-463q0-24.75 17.63-42.38Q115.25-880 140-880h544q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140v463q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM478-80q-12.75 0-21.37-8.63Q448-97.25 448-110v-50H300q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h560q24 0 42 18t18 42v440q0 24-18 42t-42 18H712v50q0 12.75-8.62 21.37Q694.75-80 682-80H478ZM300-220h560v-440H300v440Zm280-220Z"
		/>
	</svg>
);
